/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleADownIcon16Light = forwardRef('ArrowShapeTriangleADownIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.078 4a1 1 0 0 1 .838 1.545l-4.03 6.194a1 1 0 0 1-1.671.008L3.099 5.553A1 1 0 0 1 3.932 4h8.146Zm-4.03 7.194L12.078 5H3.932l4.116 6.194Z" })));
});
